export default __webpack_public_path__ + "static/media/SlipImg.84aa1df9.jpg";